import { fetchUnitsIfNeeded } from './units';
import { uniq } from 'lodash';

export const fetchEnrolledTeachingPeriodsIfNeeded = (courseId, parentSSPNo) => {
  return (dispatch, getState) => {
    if (shouldFetchEnrolledTeachingPeriods(getState(), courseId)) {
      return dispatch(fetchEnrolledTeachingPeriods(courseId, parentSSPNo));
    } else {
      return Promise.resolve();
    }
  };
};

export const generateFakeEnrolledTeachingPeriods = (
  courseId,
  teachingPeriods = []
) => {
  return dispatch => {
    dispatch(requestEnrolledTeachingPeriods(courseId));
    dispatch(receiveEnrolledTeachingPeriods(courseId, teachingPeriods));

    return Promise.resolve();
  };
};

const fetchEnrolledTeachingPeriods = (courseId, parentSSPNo) => {
  return (dispatch, getState) => {
    dispatch(requestEnrolledTeachingPeriods());

    return dispatch(fetchUnitsIfNeeded(courseId, parentSSPNo)).then(() => {
      const { units } = getState();

      //filtering 'COMPLETED' units to stop showing sliders for those completed units teaching periods - DH-303
      const calendarTypes = units[courseId]
      .items.filter ( item => item.unitStage !== 'COMP' )
      .map(
        ({ unitAvailabilityStudyPeriodCode }) => unitAvailabilityStudyPeriodCode
      );

      const uniqueCalendarTypes = uniq(calendarTypes);

      return dispatch(
        receiveEnrolledTeachingPeriods(courseId, uniqueCalendarTypes)
      );
    });
  };
};

const shouldFetchEnrolledTeachingPeriods = (state, courseId) => {
  const { isFetching, receivedAt } = state.enrolledTeachingPeriods[courseId];
  return receivedAt === null && !isFetching;
};

const requestEnrolledTeachingPeriods = courseId => {
  return {
    type: 'REQUEST_ENROLLED_TEACHING_PERIODS',
    courseId
  };
};

const receiveEnrolledTeachingPeriods = (
  courseId,
  enrolledTeachingPeriods = []
) => {
  return {
    type: 'RECEIVE_ENROLLED_TEACHING_PERIODS',
    courseId,
    teachingPeriods: enrolledTeachingPeriods
  };
};
